import { render, staticRenderFns } from "./CombinationTrades.vue?vue&type=template&id=08eee3ff&"
import script from "./CombinationTrades.vue?vue&type=script&lang=js&"
export * from "./CombinationTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports